<template>
    <div class="text-sm font-medium mt-10 text-center">
        <ul
            class="hidden gap-x-4 relative lg:gap-0 md:w-[70%] my-0 mx-auto mb-5 lg:w-full  md:flex flex-wrap justify-center lg:-mb-[7px]">
            <div class="w-[80%] top-7 lg:hidden absolute border-b border-border"></div>
            <div class="w-[72%] top-14 lg:hidden absolute border-b border-border"></div>
            <li>
                <button @click="activeTabOne" :class="{
                    'text-mainColor lg:rounded-b-lg relative z-10 border-mainColor lg:border-b-[7px] md:border-b':
                        tab === 1,
                    'text-grayCase border-none': tab !== 1,
                }" class="inline-block  lg:p-4 text-lg border-b-2">
                    All
                </button>
            </li>
            <li>
                <button @click="activeTabTwo" :class="{
                    'text-mainColor lg:rounded-b-lg relative z-10 border-mainColor lg:border-b-[7px] md:border-b':
                        tab === 2,
                    'text-grayCase border-none': tab !== 2,
                }" class="inline-block  lg:p-4 text-lg border-b-2">
                    Development
                </button>
            </li>
            <li>
                <button :class="{
                    'text-mainColor lg:rounded-b-lg relative z-10 border-mainColor lg:border-b-[7px] md:border-b':
                        tab === 3,
                    'text-grayCase border-none': tab !== 3,
                }" @click="activeTabThree" class="inline-block  lg:p-4 text-lg border-b-2">
                    Entrepreneurship
                </button>
            </li>
            <li>
                <button :class="{
                    'text-mainColor lg:rounded-b-lg relative z-10 border-mainColor lg:border-b-[7px] md:border-b':
                        tab === 4,
                    'text-grayCase border-none': tab !== 4,
                }" @click="activeTabFour" class="inline-block  lg:p-4 text-lg border-b-2">
                    Design
                </button>
            </li>
            <li>
                <button :class="{
                    'text-mainColor lg:rounded-b-lg relative z-10 border-mainColor lg:border-b-[7px] md:border-b':
                        tab === 5,
                    'text-grayCase border-none': tab !== 5,
                }" @click="activeTabFive" class="inline-block  lg:p-4 text-lg border-b-2">
                    Codica Way
                </button>
            </li>
            <li>
                <button @click="activeTabSix" :class="{
                    'text-mainColor lg:rounded-b-lg relative z-10 border-mainColor lg:border-b-[7px] md:border-b':
                        tab === 6,
                    'text-grayCase border-none': tab !== 6,
                }" class="inline-block  lg:p-4 text-lg border-b-2">
                    Technology
                </button>
            </li>
            <li>
                <button @click="activeTabSeven" :class="{
                    'text-mainColor lg:rounded-b-lg relative z-10 border-mainColor lg:border-b-[7px] md:border-b':
                        tab === 7,
                    'text-grayCase border-none': tab !== 7,
                }" class="inline-block  lg:p-4 text-lg border-b-2">
                    Management
                </button>
            </li>
        </ul>
        <div
            class="blue-rectangle flex-col md:flex-row flex w-full pt-4 pb-5 px-6 md:p-12 lg:pt-[72px] lg:pb-12 lg:px-[72px]">
            <ul class="flex gap-x-4 mb-3 md:gap-0 md:hidden flex-wrap">
                <li>
                    <button @click="activeTabOne" :class="{
                        'text-mainColor':
                            tab === 1,
                        'text-gray': tab !== 1,
                    }" class="inline-block text-sm">
                        All
                    </button>
                </li>
                <li>
                    <button @click="activeTabTwo" :class="{
                        'text-mainColor':
                            tab === 2,
                        'text-gray': tab !== 2,
                    }" class="inline-block text-sm">
                        Development
                    </button>
                </li>
                <li>
                    <button :class="{
                        'text-mainColor':
                            tab === 3,
                        'text-gray': tab !== 3,
                    }" @click="activeTabThree" class="inline-block text-sm">
                        Entrepreneurship
                    </button>
                </li>
                <li>
                    <button :class="{
                        'text-mainColor':
                            tab === 4,
                        'text-gray': tab !== 4,
                    }" @click="activeTabFour" class="inline-block text-sm">
                        Design
                    </button>
                </li>
                <li>
                    <button :class="{
                        'text-mainColor':
                            tab === 5,
                        'text-gray': tab !== 5,
                    }" @click="activeTabFive" class="inline-block text-sm">
                        Codica Way
                    </button>
                </li>
                <li>
                    <button @click="activeTabSix" :class="{
                        'text-mainColor':
                            tab === 6,
                        'text-gray': tab !== 6,
                    }" class="inline-block text-sm">
                        Technology
                    </button>
                </li>
                <li>
                    <button @click="activeTabSeven" :class="{
                        'text-mainColor':
                            tab === 7,
                        'text-gray': tab !== 7,
                    }" class="inline-block text-sm">
                        Management
                    </button>
                </li>
            </ul>
            <div v-show="tab === 1" id="indicators-carousel-allTopics" class="relative w-full">
                <div ref="carousel-allTopics-1" id="carouselAllTopics"
                    class="relative overflow-hidden w-full lg:w-11/12 lg:h-64 md:h-[34rem] h-[22rem]">
                    <div id="carousel-item-allTopics1" class="carousel-item-background duration-700 ease-in-out"
                        data-carousel-item="active">
                        <div class="flex gap-x-12 flex-col lg:flex-row">
                            <img alt="uber-eats" class="h-[216px] md:h-[390px] lg:h-auto"
                                src="../../../images/uber-eats.png" />
                            <div class="flex flex-col justify-start items-start">
                                <h3 class="lg:text-[20px] text-sm font-bold mt-3 lg:mt-0 lg:mb-5 text-mainColor">
                                    FEATURED TOPICS
                                </h3>
                                <h1
                                    class="text-white text-2xl md:text-[34px] font-trap mb-1 lg:mb-5 md:my-3 font-semibold text-left lg:text-center">
                                    How to build an app like Uber Eats
                                </h1>
                                <p
                                    class="text-grayInContainer text-xs md:leading-[26px] md:text-[16px] text-left font-semibold ">
                                    Explaining how to create an app like Uber
                                    Eats: what features to include, what
                                    technologies to use, and how much it costs.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="carousel-item-allTopics2"
                        class="carousel-item-background duration-700 text-white flex justify-center items-center rounded-3xl ease-in-out"
                        data-carousel-item>
                        <div class="flex gap-x-12 flex-col lg:flex-row">
                            <img alt="uber-eats" class="h-[216px] md:h-[390px] lg:h-auto"
                                src="../../../images/uber-eats.png" />
                            <div class="flex flex-col justify-start items-start">
                                <h3 class="lg:text-[20px] text-sm font-bold mt-3 lg:mt-0 lg:mb-5 text-mainColor">
                                    FEATURED TOPICS
                                </h3>
                                <h1
                                    class="text-white text-2xl md:text-[34px] font-trap mb-1 lg:mb-5 md:my-3 font-semibold text-left lg:text-center">
                                    How to build an app like Uber Eats
                                </h1>
                                <p
                                    class="text-grayInContainer text-xs md:leading-[26px] md:text-[16px] text-left font-semibold ">
                                    Explaining how to create an app like Uber
                                    Eats.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="carousel-item-allTopics3"
                        class="carousel-item-background duration-700 text-white flex justify-center items-center rounded-3xl ease-in-out"
                        data-carousel-item>
                        <div class="flex gap-x-12 flex-col lg:flex-row">
                            <img alt="uber-eats" class="h-[216px] md:h-[390px] lg:h-auto"
                                src="../../../images/uber-eats.png" />
                            <div class="flex flex-col justify-start items-start">
                                <h3 class="lg:text-[20px] text-sm font-bold mt-3 lg:mt-0 lg:mb-5 text-mainColor">
                                    FEATURED TOPICS
                                </h3>
                                <h1
                                    class="text-white text-2xl md:text-[34px] font-trap mb-1 lg:mb-5 md:my-3 font-semibold text-left lg:text-center">
                                    How to build an app like Uber Eats
                                </h1>
                                <p
                                    class="text-grayInContainer text-xs md:leading-[26px] md:text-[16px] text-left font-semibold ">
                                    Explaining how to create an app like Uber
                                    Eats: what features to include, what
                                    technologies to use, and how much it costs.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="flex justify-end lg:relative bottom-10 md:mt-8 lg:mt-0 carousel-arrows w-full lg:w-11/12 right-10 flex-col md:flex-row z-50 items-center">
                    <div class="flex mb-5 mt-6 lg:m-0 w-full lg:w-1/5 gap-x-6 items-center justify-center">
                        <div class="flex gap-x-4 items-center justify-center">
                            <button id="carousel-indicator-allTopics1" class="slider-indicator" aria-current="true"
                                aria-label="Slide 1" data-carousel-slide-to="0"></button>
                            <button id="carousel-indicator-allTopics2" class="slider-indicator" aria-current="false"
                                aria-label="Slide 2" data-carousel-slide-to="1"></button>
                            <button id="carousel-indicator-allTopics3" class="slider-indicator" aria-current="false"
                                aria-label="Slide 3" data-carousel-slide-to="2"></button>
                        </div>
                    </div>
                    <div class="flex w-full lg:w-2/5 gap-6 lg:gap-8 items-center">
                        <button @click="setActiveButton(0)" :class="{
                            'text-mainColor': currentIndex === 0,
                            'text-gray': currentIndex !== 0,
                        }"
                            class="lg:font-bold whitespace-nowrap text-gray md:text-[14px] text-[10px] lowercase sm:normal-case">
                            ONLINE STREAMING
                        </button>
                        <button @click="setActiveButton(1)" :class="{
                            'text-mainColor': currentIndex === 1,
                            'text-gray': currentIndex !== 1,
                        }"
                            class="lg:font-bold whitespace-nowrap text-gray md:text-[14px] text-[10px] lowercase sm:normal-case">
                            E-LEARNING PLATFORM
                        </button>
                        <button @click="setActiveButton(2)" :class="{
                            'text-mainColor': currentIndex === 2,
                            'text-gray': currentIndex !== 2,
                        }"
                            class="lg:font-bold whitespace-nowrap text-gray md:text-[14px] text-[10px] lowercase sm:normal-case">
                            UBER EATS-LIKE APP
                        </button>
                    </div>
                </div>
            </div>

            <div v-show="tab === 2" id="indicators-carousel" class="relative w-full" data-carousel="slide">
                <div ref="carousel" id="carousel"
                    class="relative overflow-hidden w-full lg:w-11/12 lg:h-64 md:h-[34rem] h-[22rem]">
                    <div id="carousel-item-1" class="carousel-item-background duration-700 ease-in-out"
                        data-carousel-item="active">
                        <div class="flex gap-x-12 flex-col lg:flex-row">
                            <img alt="uber-eats" class="h-[216px] md:h-[390px] lg:h-auto"
                                src="../../../images/uber-eats.png" />
                            <div class="flex flex-col justify-start items-start">
                                <h3 class="lg:text-[20px] text-sm font-bold mt-3 lg:mt-0 lg:mb-5 text-mainColor">
                                    FEATURED TOPICS
                                </h3>
                                <h1
                                    class="text-white text-2xl md:text-[34px] font-trap mb-1 lg:mb-5 md:my-3 font-semibold text-left lg:text-center">
                                    How to build an app like Uber Eats
                                </h1>
                                <p
                                    class="text-grayInContainer text-xs md:leading-[26px] md:text-[16px] text-left font-semibold ">
                                    Explaining how to create an app like Uber
                                    Eats: what features to include, what
                                    technologies to use, and how much it costs.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="carousel-item-2"
                        class="carousel-item-background duration-700 text-white flex justify-center items-center rounded-3xl ease-in-out"
                        data-carousel-item>
                        <div class="flex gap-x-12 flex-col lg:flex-row">
                            <img alt="uber-eats" class="h-[216px] md:h-[390px] lg:h-auto"
                                src="../../../images/uber-eats.png" />
                            <div class="flex flex-col justify-start items-start">
                                <h3 class="lg:text-[20px] text-sm font-bold mt-3 lg:mt-0 lg:mb-5 text-mainColor">
                                    FEATURED TOPICS
                                </h3>
                                <h1
                                    class="text-white text-2xl md:text-[34px] font-trap mb-1 lg:mb-5 md:my-3 font-semibold text-left lg:text-center">
                                    How to build an app like Uber Eats
                                </h1>
                                <p
                                    class="text-grayInContainer text-xs md:leading-[26px] md:text-[16px] text-left font-semibold ">
                                    Explaining how to create an app like Uber
                                    Eats: what features to include, what
                                    technologies to use, and how much it costs.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="carousel-item-3"
                        class="carousel-item-background duration-700 text-white flex justify-center items-center rounded-3xl ease-in-out"
                        data-carousel-item>
                        <div class="flex gap-x-12 flex-col lg:flex-row">
                            <img alt="uber-eats" class="h-[216px] md:h-[390px] lg:h-auto"
                                src="../../../images/uber-eats.png" />
                            <div class="flex flex-col justify-start items-start">
                                <h3 class="lg:text-[20px] text-sm font-bold mt-3 lg:mt-0 lg:mb-5 text-mainColor">
                                    FEATURED TOPICS
                                </h3>
                                <h1
                                    class="text-white text-2xl md:text-[34px] font-trap mb-1 lg:mb-5 md:my-3 font-semibold text-left lg:text-center">
                                    How to build an app like Uber Eats
                                </h1>
                                <p
                                    class="text-grayInContainer text-xs md:leading-[26px] md:text-[16px] text-left font-semibold ">
                                    Explaining how to create an app like Uber
                                    Eats: what features to include, what
                                    technologies to use, and how much it costs.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="flex justify-end lg:relative bottom-10 md:mt-8 lg:mt-0 carousel-arrows w-full lg:w-11/12 right-10 flex-col md:flex-row z-50 items-center">
                    <div class="flex mb-5 mt-6 lg:m-0 w-full lg:w-1/5 gap-x-6 items-center justify-center">
                        <div class="flex gap-x-4 items-center justify-center">
                            <button class="slider-indicator" aria-current="true" aria-label="Slide 1"
                                data-carousel-slide-to="0"></button>
                            <button class="slider-indicator" aria-current="false" aria-label="Slide 2"
                                data-carousel-slide-to="1"></button>
                            <button class="slider-indicator" aria-current="false" aria-label="Slide 3"
                                data-carousel-slide-to="2"></button>
                        </div>
                    </div>
                    <div class="flex w-full lg:w-2/5 gap-6 lg:gap-8 items-center">
                        <button @click="setActiveButton(0)" :class="{
                            'text-mainColor':
                                currentIndex === 0, 'text-gray': currentIndex !== 0,
                        }"
                            class="lg:font-bold whitespace-nowrap text-gray md:text-[14px] text-[10px] lowercase sm:normal-case">
                            ONLINE STREAMING
                        </button>
                        <button @click="setActiveButton(1)" :class="{
                            'text-mainColor':
                                currentIndex === 1, 'text-gray': currentIndex !== 1,
                        }"
                            class="lg:font-bold whitespace-nowrap text-gray md:text-[14px] text-[10px] lowercase sm:normal-case">
                            E-LEARNING PLATFORM
                        </button>
                        <button @click="setActiveButton(2)" :class="{
                            'text-mainColor':
                                currentIndex === 2, 'text-gray': currentIndex !== 2,
                        }"
                            class="lg:font-bold whitespace-nowrap text-gray md:text-[14px] text-[10px] lowercase sm:normal-case">
                            UBER EATS-LIKE APP
                        </button>
                    </div>
                </div>
            </div>

            <div v-show="tab === 3" id="indicators-carousel" class="relative w-full" data-carousel="slide">
                <div ref="carousel" id="carousel"
                    class="relative overflow-hidden w-full lg:w-11/12 lg:h-64 md:h-[34rem] h-[22rem]">
                    <div id="carousel-item-1" class="carousel-item-background duration-700 ease-in-out"
                        data-carousel-item="active">
                        <div class="flex gap-x-12 flex-col lg:flex-row">
                            <img alt="uber-eats" class="h-[216px] md:h-[390px] lg:h-auto"
                                src="../../../images/uber-eats.png" />
                            <div class="flex flex-col justify-start items-start">
                                <h3 class="lg:text-[20px] text-sm font-bold mt-3 lg:mt-0 lg:mb-5 text-mainColor">
                                    FEATURED TOPICS
                                </h3>
                                <h1
                                    class="text-white text-2xl md:text-[34px] font-trap mb-1 lg:mb-5 md:my-3 font-semibold text-left lg:text-center">
                                    How to build an app like Uber Eats
                                </h1>
                                <p
                                    class="text-grayInContainer text-xs md:leading-[26px] md:text-[16px] text-left font-semibold ">
                                    Explaining how to create an app like Uber
                                    Eats: what features to include, what
                                    technologies to use, and how much it costs.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="carousel-item-2"
                        class="carousel-item-background duration-700 text-white flex justify-center items-center rounded-3xl ease-in-out"
                        data-carousel-item>
                        <div class="flex gap-x-12 flex-col lg:flex-row">
                            <img alt="uber-eats" class="h-[216px] md:h-[390px] lg:h-auto"
                                src="../../../images/uber-eats.png" />
                            <div class="flex flex-col justify-start items-start">
                                <h3 class="lg:text-[20px] text-sm font-bold mt-3 lg:mt-0 lg:mb-5 text-mainColor">
                                    FEATURED TOPICS
                                </h3>
                                <h1
                                    class="text-white text-2xl md:text-[34px] font-trap mb-1 lg:mb-5 md:my-3 font-semibold text-left lg:text-center">
                                    How to build an app like Uber Eats
                                </h1>
                                <p
                                    class="text-grayInContainer text-xs md:leading-[26px] md:text-[16px] text-left font-semibold ">
                                    Explaining how to create an app like Uber
                                    Eats: what features to include, what
                                    technologies to use, and how much it costs.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="carousel-item-3"
                        class="carousel-item-background duration-700 text-white flex justify-center items-center rounded-3xl ease-in-out"
                        data-carousel-item>
                        <div class="flex gap-x-12 flex-col lg:flex-row">
                            <img alt="uber-eats" class="h-[216px] md:h-[390px] lg:h-auto"
                                src="../../../images/uber-eats.png" />
                            <div class="flex flex-col justify-start items-start">
                                <h3 class="lg:text-[20px] text-sm font-bold mt-3 lg:mt-0 lg:mb-5 text-mainColor">
                                    FEATURED TOPICS
                                </h3>
                                <h1
                                    class="text-white text-2xl md:text-[34px] font-trap mb-1 lg:mb-5 md:my-3 font-semibold text-left lg:text-center">
                                    How to build an app like Uber Eats
                                </h1>
                                <p
                                    class="text-grayInContainer text-xs md:leading-[26px] md:text-[16px] text-left font-semibold ">
                                    Explaining how to create an app like Uber
                                    Eats: what features to include, what
                                    technologies to use, and how much it costs.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="flex justify-end lg:relative bottom-10 md:mt-8 lg:mt-0 carousel-arrows w-full lg:w-11/12 right-10 flex-col md:flex-row z-50 items-center">
                    <div class="flex mb-5 mt-6 lg:m-0 w-full lg:w-1/5 gap-x-6 items-center justify-center">
                        <div class="flex gap-x-4 items-center justify-center">
                            <button class="slider-indicator" aria-current="true" aria-label="Slide 1"
                                data-carousel-slide-to="0"></button>
                            <button class="slider-indicator" aria-current="false" aria-label="Slide 2"
                                data-carousel-slide-to="1"></button>
                            <button class="slider-indicator" aria-current="false" aria-label="Slide 3"
                                data-carousel-slide-to="2"></button>
                        </div>
                    </div>
                    <div class="flex w-full lg:w-2/5 gap-6 lg:gap-8 items-center">
                        <button @click="setActiveButton(0)" :class="{
                            'text-mainColor':
                                currentIndex === 0, 'text-gray': currentIndex !== 0,
                        }"
                            class="lg:font-bold whitespace-nowrap text-gray md:text-[14px] text-[10px] lowercase sm:normal-case">
                            ONLINE STREAMING
                        </button>
                        <button @click="setActiveButton(1)" :class="{
                            'text-mainColor':
                                currentIndex === 1, 'text-gray': currentIndex !== 1,
                        }"
                            class="lg:font-bold whitespace-nowrap text-gray md:text-[14px] text-[10px] lowercase sm:normal-case">
                            E-LEARNING PLATFORM
                        </button>
                        <button @click="setActiveButton(2)" :class="{
                            'text-mainColor':
                                currentIndex === 2, 'text-gray': currentIndex !== 2,
                        }"
                            class="lg:font-bold whitespace-nowrap text-gray md:text-[14px] text-[10px] lowercase sm:normal-case">
                            UBER EATS-LIKE APP
                        </button>
                    </div>
                </div>
            </div>
            <div v-show="tab === 4" id="indicators-carousel" class="relative w-full" data-carousel="slide">
                <div ref="carousel" id="carousel"
                    class="relative overflow-hidden w-full lg:w-11/12 lg:h-64 md:h-[34rem] h-[22rem]">
                    <div id="carousel-item-1" class="carousel-item-background duration-700 ease-in-out"
                        data-carousel-item="active">
                        <div class="flex gap-x-12 flex-col lg:flex-row">
                            <img alt="uber-eats" class="h-[216px] md:h-[390px] lg:h-auto"
                                src="../../../images/uber-eats.png" />
                            <div class="flex flex-col justify-start items-start">
                                <h3 class="lg:text-[20px] text-sm font-bold mt-3 lg:mt-0 lg:mb-5 text-mainColor">
                                    FEATURED TOPICS
                                </h3>
                                <h1
                                    class="text-white text-2xl md:text-[34px] font-trap mb-1 lg:mb-5 md:my-3 font-semibold text-left lg:text-center">
                                    How to build an app like Uber Eats
                                </h1>
                                <p
                                    class="text-grayInContainer text-xs md:leading-[26px] md:text-[16px] text-left font-semibold ">
                                    Explaining how to create an app like Uber
                                    Eats: what features to include, what
                                    technologies to use, and how much it costs.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="carousel-item-2"
                        class="carousel-item-background duration-700 text-white flex justify-center items-center rounded-3xl ease-in-out"
                        data-carousel-item>
                        <div class="flex gap-x-12 flex-col lg:flex-row">
                            <img alt="uber-eats" class="h-[216px] md:h-[390px] lg:h-auto"
                                src="../../../images/uber-eats.png" />
                            <div class="flex flex-col justify-start items-start">
                                <h3 class="lg:text-[20px] text-sm font-bold mt-3 lg:mt-0 lg:mb-5 text-mainColor">
                                    FEATURED TOPICS
                                </h3>
                                <h1
                                    class="text-white text-2xl md:text-[34px] font-trap mb-1 lg:mb-5 md:my-3 font-semibold text-left lg:text-center">
                                    How to build an app like Uber Eats
                                </h1>
                                <p
                                    class="text-grayInContainer text-xs md:leading-[26px] md:text-[16px] text-left font-semibold ">
                                    Explaining how to create an app like Uber
                                    Eats: what features to include, what
                                    technologies to use, and how much it costs.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="carousel-item-3"
                        class="carousel-item-background duration-700 text-white flex justify-center items-center rounded-3xl ease-in-out"
                        data-carousel-item>
                        <div class="flex gap-x-12 flex-col lg:flex-row">
                            <img alt="uber-eats" class="h-[216px] md:h-[390px] lg:h-auto"
                                src="../../../images/uber-eats.png" />
                            <div class="flex flex-col justify-start items-start">
                                <h3 class="lg:text-[20px] text-sm font-bold mt-3 lg:mt-0 lg:mb-5 text-mainColor">
                                    FEATURED TOPICS
                                </h3>
                                <h1
                                    class="text-white text-2xl md:text-[34px] font-trap mb-1 lg:mb-5 md:my-3 font-semibold text-left lg:text-center">
                                    How to build an app like Uber Eats
                                </h1>
                                <p
                                    class="text-grayInContainer text-xs md:leading-[26px] md:text-[16px] text-left font-semibold ">
                                    Explaining how to create an app like Uber
                                    Eats: what features to include, what
                                    technologies to use, and how much it costs.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="flex justify-end lg:relative bottom-10 md:mt-8 lg:mt-0 carousel-arrows w-full lg:w-11/12 right-10 flex-col md:flex-row z-50 items-center">
                    <div class="flex mb-5 mt-6 lg:m-0 w-full lg:w-1/5 gap-x-6 items-center justify-center">
                        <div class="flex gap-x-4 items-center justify-center">
                            <button class="slider-indicator" aria-current="true" aria-label="Slide 1"
                                data-carousel-slide-to="0"></button>
                            <button class="slider-indicator" aria-current="false" aria-label="Slide 2"
                                data-carousel-slide-to="1"></button>
                            <button class="slider-indicator" aria-current="false" aria-label="Slide 3"
                                data-carousel-slide-to="2"></button>
                        </div>
                    </div>
                    <div class="flex w-full lg:w-2/5 gap-6 lg:gap-8 items-center">
                        <button @click="setActiveButton(0)" :class="{
                            'text-mainColor':
                                currentIndex === 0, 'text-gray': currentIndex !== 0,
                        }"
                            class="lg:font-bold whitespace-nowrap text-gray md:text-[14px] text-[10px] lowercase sm:normal-case">
                            ONLINE STREAMING
                        </button>
                        <button @click="setActiveButton(1)" :class="{
                            'text-mainColor':
                                currentIndex === 1, 'text-gray': currentIndex !== 1,
                        }"
                            class="lg:font-bold whitespace-nowrap text-gray md:text-[14px] text-[10px] lowercase sm:normal-case">
                            E-LEARNING PLATFORM
                        </button>
                        <button @click="setActiveButton(2)" :class="{
                            'text-mainColor':
                                currentIndex === 2, 'text-gray': currentIndex !== 2,
                        }"
                            class="lg:font-bold whitespace-nowrap text-gray md:text-[14px] text-[10px] lowercase sm:normal-case">
                            UBER EATS-LIKE APP
                        </button>
                    </div>
                </div>
            </div>

            <div v-show="tab === 5" id="indicators-carousel" class="relative w-full" data-carousel="slide">
                <div ref="carousel" id="carousel"
                    class="relative overflow-hidden w-full lg:w-11/12 lg:h-64 md:h-[34rem] h-[22rem]">
                    <div id="carousel-item-1" class="carousel-item-background duration-700 ease-in-out"
                        data-carousel-item="active">
                        <div class="flex gap-x-12 flex-col lg:flex-row">
                            <img alt="uber-eats" class="h-[216px] md:h-[390px] lg:h-auto"
                                src="../../../images/uber-eats.png" />
                            <div class="flex flex-col justify-start items-start">
                                <h3 class="lg:text-[20px] text-sm font-bold mt-3 lg:mt-0 lg:mb-5 text-mainColor">
                                    FEATURED TOPICS
                                </h3>
                                <h1
                                    class="text-white text-2xl md:text-[34px] font-trap mb-1 lg:mb-5 md:my-3 font-semibold text-left lg:text-center">
                                    How to build an app like Uber Eats
                                </h1>
                                <p
                                    class="text-grayInContainer text-xs md:leading-[26px] md:text-[16px] text-left font-semibold ">
                                    Explaining how to create an app like Uber
                                    Eats: what features to include, what
                                    technologies to use, and how much it costs.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="carousel-item-2"
                        class="carousel-item-background duration-700 text-white flex justify-center items-center rounded-3xl ease-in-out"
                        data-carousel-item>
                        <div class="flex gap-x-12 flex-col lg:flex-row">
                            <img alt="uber-eats" class="h-[216px] md:h-[390px] lg:h-auto"
                                src="../../../images/uber-eats.png" />
                            <div class="flex flex-col justify-start items-start">
                                <h3 class="lg:text-[20px] text-sm font-bold mt-3 lg:mt-0 lg:mb-5 text-mainColor">
                                    FEATURED TOPICS
                                </h3>
                                <h1
                                    class="text-white text-2xl md:text-[34px] font-trap mb-1 lg:mb-5 md:my-3 font-semibold text-left lg:text-center">
                                    How to build an app like Uber Eats
                                </h1>
                                <p
                                    class="text-grayInContainer text-xs md:leading-[26px] md:text-[16px] text-left font-semibold ">
                                    Explaining how to create an app like Uber
                                    Eats: what features to include, what
                                    technologies to use, and how much it costs.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="carousel-item-3"
                        class="carousel-item-background duration-700 text-white flex justify-center items-center rounded-3xl ease-in-out"
                        data-carousel-item>
                        <div class="flex gap-x-12 flex-col lg:flex-row">
                            <img alt="uber-eats" class="h-[216px] md:h-[390px] lg:h-auto"
                                src="../../../images/uber-eats.png" />
                            <div class="flex flex-col justify-start items-start">
                                <h3 class="lg:text-[20px] text-sm font-bold mt-3 lg:mt-0 lg:mb-5 text-mainColor">
                                    FEATURED TOPICS
                                </h3>
                                <h1
                                    class="text-white text-2xl md:text-[34px] font-trap mb-1 lg:mb-5 md:my-3 font-semibold text-left lg:text-center">
                                    How to build an app like Uber Eats
                                </h1>
                                <p
                                    class="text-grayInContainer text-xs md:leading-[26px] md:text-[16px] text-left font-semibold ">
                                    Explaining how to create an app like Uber
                                    Eats: what features to include, what
                                    technologies to use, and how much it costs.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="flex justify-end lg:relative bottom-10 md:mt-8 lg:mt-0 carousel-arrows w-full lg:w-11/12 right-10 flex-col md:flex-row z-50 items-center">
                    <div class="flex mb-5 mt-6 lg:m-0 w-full lg:w-1/5 gap-x-6 items-center justify-center">
                        <div class="flex gap-x-4 items-center justify-center">
                            <button class="slider-indicator" aria-current="true" aria-label="Slide 1"
                                data-carousel-slide-to="0"></button>
                            <button class="slider-indicator" aria-current="false" aria-label="Slide 2"
                                data-carousel-slide-to="1"></button>
                            <button class="slider-indicator" aria-current="false" aria-label="Slide 3"
                                data-carousel-slide-to="2"></button>
                        </div>
                    </div>
                    <div class="flex w-full lg:w-2/5 gap-6 lg:gap-8 items-center">
                        <button @click="setActiveButton(0)" :class="{
                            'text-mainColor':
                                currentIndex === 0, 'text-gray': currentIndex !== 0,
                        }"
                            class="lg:font-bold whitespace-nowrap text-gray md:text-[14px] text-[10px] lowercase sm:normal-case">
                            ONLINE STREAMING
                        </button>
                        <button @click="setActiveButton(1)" :class="{
                            'text-mainColor':
                                currentIndex === 1, 'text-gray': currentIndex !== 1,
                        }"
                            class="lg:font-bold whitespace-nowrap text-gray md:text-[14px] text-[10px] lowercase sm:normal-case">
                            E-LEARNING PLATFORM
                        </button>
                        <button @click="setActiveButton(2)" :class="{
                            'text-mainColor':
                                currentIndex === 2, 'text-gray': currentIndex !== 2,
                        }"
                            class="lg:font-bold whitespace-nowrap text-gray md:text-[14px] text-[10px] lowercase sm:normal-case">
                            UBER EATS-LIKE APP
                        </button>
                    </div>
                </div>
            </div>
            <div v-show="tab === 6" id="indicators-carousel" class="relative w-full" data-carousel="slide">
                <div ref="carousel" id="carousel"
                    class="relative overflow-hidden w-full lg:w-11/12 lg:h-64 md:h-[34rem] h-[22rem]">
                    <div id="carousel-item-1" class="carousel-item-background duration-700 ease-in-out"
                        data-carousel-item="active">
                        <div class="flex gap-x-12 flex-col lg:flex-row">
                            <img alt="uber-eats" class="h-[216px] md:h-[390px] lg:h-auto"
                                src="../../../images/uber-eats.png" />
                            <div class="flex flex-col justify-start items-start">
                                <h3 class="lg:text-[20px] text-sm font-bold mt-3 lg:mt-0 lg:mb-5 text-mainColor">
                                    FEATURED TOPICS
                                </h3>
                                <h1
                                    class="text-white text-2xl md:text-[34px] font-trap mb-1 lg:mb-5 md:my-3 font-semibold text-left lg:text-center">
                                    How to build an app like Uber Eats
                                </h1>
                                <p
                                    class="text-grayInContainer text-xs md:leading-[26px] md:text-[16px] text-left font-semibold ">
                                    Explaining how to create an app like Uber
                                    Eats: what features to include, what
                                    technologies to use, and how much it costs.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="carousel-item-2"
                        class="carousel-item-background duration-700 text-white flex justify-center items-center rounded-3xl ease-in-out"
                        data-carousel-item>
                        <div class="flex gap-x-12 flex-col lg:flex-row">
                            <img alt="uber-eats" class="h-[216px] md:h-[390px] lg:h-auto"
                                src="../../../images/uber-eats.png" />
                            <div class="flex flex-col justify-start items-start">
                                <h3 class="lg:text-[20px] text-sm font-bold mt-3 lg:mt-0 lg:mb-5 text-mainColor">
                                    FEATURED TOPICS
                                </h3>
                                <h1
                                    class="text-white text-2xl md:text-[34px] font-trap mb-1 lg:mb-5 md:my-3 font-semibold text-left lg:text-center">
                                    How to build an app like Uber Eats
                                </h1>
                                <p
                                    class="text-grayInContainer text-xs md:leading-[26px] md:text-[16px] text-left font-semibold ">
                                    Explaining how to create an app like Uber
                                    Eats: what features to include, what
                                    technologies to use, and how much it costs.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="carousel-item-3"
                        class="carousel-item-background duration-700 text-white flex justify-center items-center rounded-3xl ease-in-out"
                        data-carousel-item>
                        <div class="flex gap-x-12 flex-col lg:flex-row">
                            <img alt="uber-eats" class="h-[216px] md:h-[390px] lg:h-auto"
                                src="../../../images/uber-eats.png" />
                            <div class="flex flex-col justify-start items-start">
                                <h3 class="lg:text-[20px] text-sm font-bold mt-3 lg:mt-0 lg:mb-5 text-mainColor">
                                    FEATURED TOPICS
                                </h3>
                                <h1
                                    class="text-white text-2xl md:text-[34px] font-trap mb-1 lg:mb-5 md:my-3 font-semibold text-left lg:text-center">
                                    How to build an app like Uber Eats
                                </h1>
                                <p
                                    class="text-grayInContainer text-xs md:leading-[26px] md:text-[16px] text-left font-semibold ">
                                    Explaining how to create an app like Uber
                                    Eats: what features to include, what
                                    technologies to use, and how much it costs.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="flex justify-end lg:relative bottom-10 md:mt-8 lg:mt-0 carousel-arrows w-full lg:w-11/12 right-10 flex-col md:flex-row z-50 items-center">
                    <div class="flex mb-5 mt-6 lg:m-0 w-full lg:w-1/5 gap-x-6 items-center justify-center">
                        <div class="flex gap-x-4 items-center justify-center">
                            <button class="slider-indicator" aria-current="true" aria-label="Slide 1"
                                data-carousel-slide-to="0"></button>
                            <button class="slider-indicator" aria-current="false" aria-label="Slide 2"
                                data-carousel-slide-to="1"></button>
                            <button class="slider-indicator" aria-current="false" aria-label="Slide 3"
                                data-carousel-slide-to="2"></button>
                        </div>
                    </div>
                    <div class="flex w-full lg:w-2/5 gap-6 lg:gap-8 items-center">
                        <button @click="setActiveButton(0)" :class="{
                            'text-mainColor':
                                currentIndex === 0, 'text-gray': currentIndex !== 0,
                        }"
                            class="lg:font-bold whitespace-nowrap text-gray md:text-[14px] text-[10px] lowercase sm:normal-case">
                            ONLINE STREAMING
                        </button>
                        <button @click="setActiveButton(1)" :class="{
                            'text-mainColor':
                                currentIndex === 1, 'text-gray': currentIndex !== 1,
                        }"
                            class="lg:font-bold whitespace-nowrap text-gray md:text-[14px] text-[10px] lowercase sm:normal-case">
                            E-LEARNING PLATFORM
                        </button>
                        <button @click="setActiveButton(2)" :class="{
                            'text-mainColor':
                                currentIndex === 2, 'text-gray': currentIndex !== 2,
                        }"
                            class="lg:font-bold whitespace-nowrap text-gray md:text-[14px] text-[10px] lowercase sm:normal-case">
                            UBER EATS-LIKE APP
                        </button>
                    </div>
                </div>
            </div>
            <div v-show="tab === 7" id="indicators-carousel" class="relative w-full" data-carousel="slide">
                <div ref="carousel" id="carousel"
                    class="relative overflow-hidden w-full lg:w-11/12 lg:h-64 md:h-[34rem] h-[22rem]">
                    <div id="carousel-item-1" class="carousel-item-background duration-700 ease-in-out"
                        data-carousel-item="active">
                        <div class="flex gap-x-12 flex-col lg:flex-row">
                            <img alt="uber-eats" class="h-[216px] md:h-[390px] lg:h-auto"
                                src="../../../images/uber-eats.png" />
                            <div class="flex flex-col justify-start items-start">
                                <h3 class="lg:text-[20px] text-sm font-bold mt-3 lg:mt-0 lg:mb-5 text-mainColor">
                                    FEATURED TOPICS
                                </h3>
                                <h1
                                    class="text-white text-2xl md:text-[34px] font-trap mb-1 lg:mb-5 md:my-3 font-semibold text-left lg:text-center">
                                    How to build an app like Uber Eats
                                </h1>
                                <p
                                    class="text-grayInContainer text-xs md:leading-[26px] md:text-[16px] text-left font-semibold ">
                                    Explaining how to create an app like Uber
                                    Eats: what features to include, what
                                    technologies to use, and how much it costs.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="carousel-item-2"
                        class="carousel-item-background duration-700 text-white flex justify-center items-center rounded-3xl ease-in-out"
                        data-carousel-item>
                        <div class="flex gap-x-12 flex-col lg:flex-row">
                            <img alt="uber-eats" class="h-[216px] md:h-[390px] lg:h-auto"
                                src="../../../images/uber-eats.png" />
                            <div class="flex flex-col justify-start items-start">
                                <h3 class="lg:text-[20px] text-sm font-bold mt-3 lg:mt-0 lg:mb-5 text-mainColor">
                                    FEATURED TOPICS
                                </h3>
                                <h1
                                    class="text-white text-2xl md:text-[34px] font-trap mb-1 lg:mb-5 md:my-3 font-semibold text-left lg:text-center">
                                    How to build an app like Uber Eats
                                </h1>
                                <p
                                    class="text-grayInContainer text-xs md:leading-[26px] md:text-[16px] text-left font-semibold ">
                                    Explaining how to create an app like Uber
                                    Eats: what features to include, what
                                    technologies to use, and how much it costs.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="carousel-item-3"
                        class="carousel-item-background duration-700 text-white flex justify-center items-center rounded-3xl ease-in-out"
                        data-carousel-item>
                        <div class="flex gap-x-12 flex-col lg:flex-row">
                            <img alt="uber-eats" class="h-[216px] md:h-[390px] lg:h-auto"
                                src="../../../images/uber-eats.png" />
                            <div class="flex flex-col justify-start items-start">
                                <h3 class="lg:text-[20px] text-sm font-bold mt-3 lg:mt-0 lg:mb-5 text-mainColor">
                                    FEATURED TOPICS
                                </h3>
                                <h1
                                    class="text-white text-2xl md:text-[34px] font-trap mb-1 lg:mb-5 md:my-3 font-semibold text-left lg:text-center">
                                    How to build an app like Uber Eats
                                </h1>
                                <p
                                    class="text-grayInContainer text-xs md:leading-[26px] md:text-[16px] text-left font-semibold ">
                                    Explaining how to create an app like Uber
                                    Eats: what features to include, what
                                    technologies to use, and how much it costs.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="flex justify-end lg:relative bottom-10 md:mt-8 lg:mt-0 carousel-arrows w-full lg:w-11/12 right-10 flex-col md:flex-row z-50 items-center">
                    <div class="flex mb-5 mt-6 lg:m-0 w-full lg:w-1/5 gap-x-6 items-center justify-center">
                        <div class="flex gap-x-4 items-center justify-center">
                            <button class="slider-indicator" aria-current="true" aria-label="Slide 1"
                                data-carousel-slide-to="0"></button>
                            <button class="slider-indicator" aria-current="false" aria-label="Slide 2"
                                data-carousel-slide-to="1"></button>
                            <button class="slider-indicator" aria-current="false" aria-label="Slide 3"
                                data-carousel-slide-to="2"></button>
                        </div>
                    </div>
                    <div class="flex w-full lg:w-2/5 gap-6 lg:gap-8 items-center">
                        <button @click="setActiveButton(0)" :class="{
                            'text-mainColor':
                                currentIndex === 0, 'text-gray': currentIndex !== 0,
                        }"
                            class="lg:font-bold whitespace-nowrap text-gray md:text-[14px] text-[10px] lowercase sm:normal-case">
                            ONLINE STREAMING
                        </button>
                        <button @click="setActiveButton(1)" :class="{
                            'text-mainColor':
                                currentIndex === 1, 'text-gray': currentIndex !== 1,
                        }"
                            class="lg:font-bold whitespace-nowrap text-gray md:text-[14px] text-[10px] lowercase sm:normal-case">
                            E-LEARNING PLATFORM
                        </button>
                        <button @click="setActiveButton(2)" :class="{
                            'text-mainColor':
                                currentIndex === 2, 'text-gray': currentIndex !== 2,
                        }"
                            class="lg:font-bold whitespace-nowrap text-gray md:text-[14px] text-[10px] lowercase sm:normal-case">
                            UBER EATS-LIKE APP
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Carousel } from "flowbite";

export default {
    name: "BlogTabs",
    data() {
        return {
            tab: 1,
            currentIndex: 0,
            buttons: [0, 1, 2],
            touchStartXAllTopics: 0,
            touchEndXAllTopics: 0,
            carouselAllTopics: null,
            activeFirstButton: null,
            activeSecondButton: null,
            activeThirdButton: null
        };
    },
    methods: {
        activeTabOne() {
            this.tab = 1;
        },
        activeTabTwo() {
            this.tab = 2;
        },
        activeTabThree() {
            this.tab = 3;
        },
        activeTabFour() {
            this.tab = 4;
        },
        activeTabFive() {
            this.tab = 5;
        },
        activeTabSix() {
            this.tab = 6;
        },
        activeTabSeven() {
            this.tab = 7;
        },
        setActiveButton(index) {
            if (index === 0) {
                this.carouselAllTopics.slideTo(0)
            } else if (index === 1) {
                this.carouselAllTopics.slideTo(1)
            } else {
                this.carouselAllTopics.slideTo(2)
            }
            this.currentIndex = index;
        },
        switchToNextButton() {
            const nextIndex = (this.currentIndex + 1) % this.buttons.length;
            this.setActiveButton(nextIndex);
        },
    },
    mounted() {
        const itemsAllTopics = [
            {
                position: 0,
                el: document.getElementById("carousel-item-allTopics1"),
            },
            {
                position: 1,
                el: document.getElementById("carousel-item-allTopics2"),
            },
            {
                position: 2,
                el: document.getElementById("carousel-item-allTopics3"),
            },
        ];

        const optionsAllTopics = {
            defaultPosition: 0,
            interval: 3000,
            indicators: {
                items: [
                    {
                        position: 0,
                        el: document.getElementById("carousel-indicator-allTopics1"),
                    },
                    {
                        position: 1,
                        el: document.getElementById("carousel-indicator-allTopics2"),
                    },
                    {
                        position: 2,
                        el: document.getElementById("carousel-indicator-allTopics3"),
                    },
                ],
            },
        };
        this.carouselAllTopics = new Carousel(itemsAllTopics, optionsAllTopics);
        const carouselAllTopicsElement = document.getElementById("carouselAllTopics");
        this.carouselAllTopics.cycle()

        const handleTouchStartAllTopics = (event) => {
            this.touchStartXAllTopics = event.touches[0].clientX;
        }

        const handleTouchEndAllTopics = (event) => {
            this.touchEndXAllTopics = event.changedTouches[0].clientX;
            handleSwipeAllTopics();
        }

        const handleSwipeAllTopics = () => {
            const swipeThreshold = 50;
            const swipeDistance = this.touchEndXAllTopics - this.touchStartXAllTopics;

            if (swipeDistance > swipeThreshold) {
                this.carouselAllTopics.prev();
            } else if (swipeDistance < -swipeThreshold) {
                this.carouselAllTopics.next();
            }
        }
        carouselAllTopicsElement.addEventListener(
            "touchstart",
            handleTouchStartAllTopics, { passive: true }
        );
        carouselAllTopicsElement.addEventListener(
            "touchend",
            handleTouchEndAllTopics, { passive: true }
        );
        this.buttonInterval = setInterval(this.switchToNextButton, 3100);
    },
    beforeDestroy() {
        clearInterval(this.buttonInterval);
    },

};
</script>
